import { AbstractClassified, setClassifiedSymbols } from '../../types/lux'

export default AbstractClassified

/** @constructor @extends {AbstractClassified} @suppress {checkTypes} */ function _Classified() {}
AbstractClassified.__implement(
  _Classified.prototype = /** @type {!AbstractClassified} */ ({
    initialiser({ classes } = {}) {
      setClassifiedSymbols(this, {
        _classes:classes,
      })
      return this
    },
    // get classList() {
    //   const{asIElemental:{element}}=this
    //   return element.classList
    // },
  }),
)
